import React, { useState } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { Modal, Button, Status } from "@bitcine/cs-theme"
import { can, VIEW_SCREENER_ANALYTICS } from "@src/helpers/authorization"
import { push } from "connected-react-router"
import {
  toggleAnalyticsModal,
  removeScreenerFromRoom,
  swapScreenerPositions
} from "@api/screener_rooms/"
import "../styles.scss"
import DropdownOptions from "../../../project/screener/dropdown_options"

const OverlayActions = ({
  screener,
  project,
  organizationId,
  screenerRoom,
  canModify,
  toggleAnalyticsModal,
  removeScreenerFromRoom,
  canViewScreenerAnalytics,
  swapScreenerPositions,
  updating,
  updateThumbnail
}) => {
  const [screenerToRemove, setScreenerToRemove] = useState(false)
  if (updating) {
    return <div className={"flex absolute top-0 right-0 left-0 bottom-0"}>
      <Status pending height={'20px'}/>
    </div>
  }
  return (
    <div
      onClick={e => e.stopPropagation() && e.preventDefault()}
      className={`flex items-center absolute top-0 left-0 right-0 mx1 mt1 ${
        canModify ? "justify-between" : "justify-end"
      }`}>
      <div className='flex items-center'>
        {canModify && screener.order !== 0 && (
          <button
            data-tooltip='Move up in room'
            className={`cs-button tooltip link material-icons mr1 arrowIcon`}
            onClick={e => {
              e.stopPropagation()
              e.preventDefault()
              swapScreenerPositions(
                organizationId,
                screenerRoom,
                screener.project_id,
                screener.order,
                screener.order - 1
              )
            }}>
            keyboard_arrow_left
          </button>
        )}
        {canModify && screener.order !== project.screeners.length - 1 && (
          <button
            data-tooltip='Move down in room'
            className={`cs-button tooltip link material-icons mr1 arrowIcon`}
            onClick={e => {
              e.stopPropagation()
              e.preventDefault()
              swapScreenerPositions(
                organizationId,
                screenerRoom,
                screener.project_id,
                screener.order,
                screener.order + 1
              )
            }}>
            keyboard_arrow_right
          </button>
        )}
      </div>
      <DropdownOptions
        screener={screener}
        updateThumbnail={updateThumbnail}
        hoverOnly
        options={[
          {
            text: "View analytics",
            icon: "bar_chart",
            onClick: () => toggleAnalyticsModal(screener),
            show: canViewScreenerAnalytics
          },
          {
            text: "Remove from room",
            icon: "remove_circle_outline",
            onClick: () => setScreenerToRemove(screener),
            show: canModify
          }
        ]}/>
      {screenerToRemove && (
        <Modal open onClose={() => setScreenerToRemove(null)} title='Remove Screener'>
          <p>
            Are you sure you want to remove <b>{screenerToRemove.name}</b> from your screener room?
          </p>
          <div className='flex justify-end mt2'>
            <div className='flex items-center'>
              <Button
                className='ml2'
                onClick={() => {
                  removeScreenerFromRoom(
                    organizationId,
                    screenerRoom._id,
                    screenerToRemove.project_id,
                    [screenerToRemove._id],
                    // notifyReviewers
                  ),
                  setScreenerToRemove(null)
                }}>
                Remove Screener
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  )
}

OverlayActions.propTypes = {
  screener: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
  toggleAnalyticsModal: PropTypes.func.isRequired,
  removeScreenerFromRoom: PropTypes.func.isRequired,
  organizationId: PropTypes.string.isRequired,
  screenerRoom: PropTypes.object.isRequired,
  canModify: PropTypes.bool.isRequired,
  canViewScreenerAnalytics: PropTypes.bool.isRequired,
  push: PropTypes.func.isRequired,
  swapScreenerPositions: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  organizationId: state.user.auth.organization_id,
  screenerRoom: state.screener_rooms.screenerRoom.data,
  canViewScreenerAnalytics: can(state.user.auth, [VIEW_SCREENER_ANALYTICS])
})

const mapDispatchToProps = dispatch => ({
  toggleAnalyticsModal: bindActionCreators(toggleAnalyticsModal, dispatch),
  removeScreenerFromRoom: bindActionCreators(removeScreenerFromRoom, dispatch),
  push: bindActionCreators(push, dispatch),
  swapScreenerPositions: bindActionCreators(swapScreenerPositions, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(OverlayActions)
